import { useStoreMap } from 'effector-react'
import { supportModel } from '~/widgets/Support'
import { Content } from '~/widgets/Support/ui/styled'
import { SupportCmsBlockEnum } from '~/shared/config/enums'
import { DrawerComponent } from '~/shared/ui/Drawer'

type BreakdownOnRoadProps = {
  isShow: boolean
  onClose: () => void
}

export function BreakdownOnRoad({ isShow, onClose }: BreakdownOnRoadProps) {
  const [support] = useStoreMap(supportModel.$supports, (support) =>
    (support || [])?.map((support) => ({
      ...support.getAttributes(),
      id: support.getApiId() as string,
    })),
  ).filter(({ position }) => position === SupportCmsBlockEnum.BREAKDOWN_ON_ROAD)

  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      <Content
        dangerouslySetInnerHTML={{
          __html: support?.content || 'Контент не найден',
        }}
      />
    </DrawerComponent>
  )
}
